export enum OfferVariant {
  Loading = 'loading',
  Popular = 'popular',
  BestDeal = 'bestDeal',
  MemberDeal = 'memberDeal',
  MemberPlusDeal = 'memberPlusDeal',
  OnlyOnVio = 'onlyOnVio',
  GreatDeal = 'greatDeal'
}
